module.exports = "img/8.f3cd01.webp";